import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Moment from 'moment-timezone'
import MenuItemGroup from './MenuItemGroup'
import FlexContainer from '@components/common/FlexContainer'
import {
  FormInputContainer,
  MenuItemDropdown,
} from '@res/styledComponents/index'
import LinkText from '@components/common/form/LinkText'
import XSpacing from '@components/common/XSpacing'
import Loader from '@components/common/Loader'

class ItemPicker extends Component {
  refreshingMenu = false
  state = {
    selectedChef: undefined,
    view: 'all',
    concepts: [],
    menuItems: {},
    menuSearch: '',
    serviceItems: [],
    virtualItems: [],
    virtualKits: [],
    snackPacks: [],
    loadChefs: () => [],
    showDropdown: false,
  }

  componentDidMount() {
    const { selectedChef, clientSetUpTime, loadChefs, orderId, proposalId } =
      this.props
    if (selectedChef) {
      this.setState({ selectedChef })
    }
    if (clientSetUpTime) {
      this.setState({
        loadChefs: loadChefs({ clientSetUpTime, orderId, proposalId }),
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      selectedChef,
      clientSetUpTime,
      loadChefs,
      orderId,
      proposalId,
      orderType,
    } = nextProps

    if (
      selectedChef !== this.props.selectedChef ||
      orderType !== this.props.orderType
    ) {
      this.setState({ selectedChef })
    }

    if (nextProps.clientSetUpTime !== this.props.clientSetUpTime) {
      this.setState({
        loadChefs: loadChefs({ clientSetUpTime, orderId, proposalId }),
      })
    }
  }

  refreshMenu = () => {
    if (this.refreshingMenu) {
      return
    }
    this.refreshingMenu = true

    try {
      const {
        loadCateringMenuItems,
        loadConcepts,
        loadServiceItems,
        loadVirtualItems,
        loadVirtualKits,
        loadSnackPacks,
        orderType,
      } = this.props
      const { selectedChef } = this.state
      if (!selectedChef) {
        this.setState({
          concepts: [],
          menuItems: {},
        })
        this.refreshingMenu = false

        return
      }
      const conPromise = loadConcepts(selectedChef.id, orderType)
      const menuPromise = loadCateringMenuItems(selectedChef.id)
      const svcPromise = loadServiceItems(selectedChef.id)
      const virtPromise = loadVirtualItems(selectedChef.id)
      const virtKPromise = loadVirtualKits(selectedChef.id)
      const snackPromise = loadSnackPacks(selectedChef.id)

      Promise.all([
        conPromise,
        menuPromise,
        svcPromise,
        virtPromise,
        virtKPromise,
        snackPromise,
      ]).then(
        ([
          concepts,
          menuItems,
          serviceItems,
          virtualItems,
          virtualKits,
          snackPacks,
        ]) => {
          this.setState({
            concepts,
            menuItems,
            serviceItems,
            virtualItems,
            virtualKits,
            snackPacks,
          })
        },
      )
    } catch (e) {
      console.log(e)
    }
    this.refreshingMenu = false
  }

  onCreateCustomMenuItem = (mealType) => () => {
    const { selectedChef: chef } = this.state

    this.props.onCreateCustomMenuItem({ chef, mealType })
  }

  onCreateCustomServiceItem = () => {
    const { selectedChef: chef } = this.state

    this.props.onCreateCustomServiceItem({ chef })
  }

  onCreateCustomVirtualItem = () => {
    const { selectedChef: chef } = this.state

    this.props.onCreateCustomVirtualItem({ chef })
  }

  onSearchMenuItem = (e) => {
    if (this.state.view == 'all') {
      this.setState({ menuSearch: e.target.value })
    } else {
      this.setState(
        { menuSearch: e.target.value, view: 'all' },
        this.refreshMenu,
      )
    }
  }

  onSelectChef = (chef) => {
    this.setState({ selectedChef: chef }, () => {
      this.refreshMenu()

      this.props.onSelectChef(chef)
    })
  }

  onSelectView = (e) => {
    const view = e.target.value

    this.setState({ view }, this.refreshMenu)
  }

  onSelectMenuItem = (menuItem) => {
    this.setState({ menuSearch: '', showDropdown: false })
    this.props.onSelectMenuItem(menuItem)
  }

  onSelectConceptMenuItem = (conceptId, conceptName) => (menuItem) => {
    this.setState({ menuSearch: '', showDropdown: false })
    this.props.onSelectMenuItem(menuItem, conceptId, conceptName)
  }

  onSelectServiceItem = (serviceItem) => {
    this.setState({ showDropdown: false })
    this.props.onSelectServiceItem(serviceItem)
  }

  onSelectVirtualItem = (virtualItem) => {
    this.setState({ showDropdown: false })
    this.props.onSelectVirtualItem(virtualItem)
  }

  onSelectVirtualKit = (virtualKit) => {
    this.setState({ showDropdown: false })
    this.props.onSelectVirtualKit(virtualKit)
  }

  onSelectSnackPack = (snackPack) => {
    this.setState({ showDropdown: false })
    this.props.onSelectSnackPack(snackPack)
  }

  renderMenuItems() {
    const {
      orderType,
      filterMenuItems,
      selectedConceptId,
      selectedMenuItems,
      selectedServiceItems,
      selectedVirtualItems,
      selectedVirtualKits,
      selectedSnackPacks,
    } = this.props
    const { menuSearch, concepts, showDropdown } = this.state
    let {
      entrees = [],
      sides = [],
      desserts = [],
      drinks = [],
      appetizers = [],
    } = this.state.menuItems

    const isVCX = orderType === 'VCX'
    const isSnackPack = orderType === 'Snack Pack'

    const selectedIds = new Set(selectedMenuItems.map((e) => e.menuItemId))
    entrees = entrees.filter((s) => !selectedIds.has(s.menuItemId))
    sides = sides.filter((s) => !selectedIds.has(s.menuItemId))
    desserts = desserts.filter((s) => !selectedIds.has(s.menuItemId))
    drinks = drinks.filter((s) => !selectedIds.has(s.menuItemId))
    appetizers = appetizers.filter((s) => !selectedIds.has(s.menuItemId))

    let {
      serviceItems = [],
      virtualItems = [],
      virtualKits = [],
      snackPacks = [],
    } = this.state
    const selectedServiceItemIds = new Set(
      selectedServiceItems.map((e) => e.serviceItemId),
    )
    serviceItems = serviceItems.filter(
      (s) => !selectedServiceItemIds.has(s.serviceItemId),
    )
    const selectedVirtualItemIds = new Set(
      selectedVirtualItems.map((e) => e.virtualItemId),
    )
    virtualItems = virtualItems.filter(
      (s) => !selectedVirtualItemIds.has(s.virtualItemId),
    )
    const selectedVirtualKitIds = new Set(
      selectedVirtualKits.map((e) => e.virtualKitId),
    )
    virtualKits = virtualKits.filter(
      (s) => !selectedVirtualKitIds.has(s.virtualKitId),
    )
    const selectedSnackPackIds = new Set(
      selectedSnackPacks.map((e) => e.snackPackId),
    )
    snackPacks = snackPacks.filter(
      (s) => !selectedSnackPackIds.has(s.snackPackId),
    )

    if (menuSearch) {
      entrees = filterMenuItems(entrees, menuSearch)
      sides = filterMenuItems(sides, menuSearch)
      desserts = filterMenuItems(desserts, menuSearch)
      drinks = filterMenuItems(drinks, menuSearch)
      appetizers = filterMenuItems(appetizers, menuSearch)
      serviceItems = filterMenuItems(serviceItems, menuSearch)
      virtualItems = filterMenuItems(virtualItems, menuSearch)
      virtualKits = filterMenuItems(virtualKits, menuSearch)
      snackPacks = filterMenuItems(snackPacks, menuSearch)
    }

    const snackPackSections = [
      {
        name: 'Snack Packs',
        items: snackPacks,
      },
    ]

    const nonVCXSections = [
      {
        name: 'Entrees',
        items: entrees,
        addCustomText: 'Add Custom Entree Item',
        className: 'add-custom',
        onCreateCustom: this.onCreateCustomMenuItem('Main'),
      },
      {
        name: 'Sides',
        items: sides,
        addCustomText: 'Add Custom Side Item',
        className: 'add-custom',
        onCreateCustom: this.onCreateCustomMenuItem('Side'),
      },
      {
        name: 'Desserts',
        items: desserts,
        addCustomText: 'Add Custom Dessert Item',
        className: 'add-custom',
        onCreateCustom: this.onCreateCustomMenuItem('Dessert'),
      },
      {
        name: 'Drinks',
        items: drinks,
        addCustomText: 'Add Custom Drink Item',
        className: 'add-custom',
        onCreateCustom: this.onCreateCustomMenuItem('Drink'),
      },
      {
        name: 'Appetizers',
        items: appetizers,
        addCustomText: 'Add Custom Appetizer Item',
        className: 'add-custom',
        onCreateCustom: this.onCreateCustomMenuItem('Appetizer'),
      },
      {
        name: 'Service Items',
        items: serviceItems,
        className: 'add-custom',
        addCustomText: 'Add Custom Service Item',
        onCreateCustom: this.onCreateCustomServiceItem,
      },
    ]

    const vItemSections = [
      {
        name: 'Virtual Items',
        items: virtualItems,
        className: 'add-custom',
        addCustomText: 'Add Custom Virtual Item',
        onCreateCustom: this.onCreateCustomVirtualItem,
      },
    ]

    const vKitSections = [
      {
        name: 'Virtual Kits',
        items: virtualKits,
      },
    ]

    const sections = []
    if (isVCX) {
      sections.push(...vItemSections, ...vKitSections)
    } else if (isSnackPack) {
      sections.push(...vItemSections, ...snackPackSections)
    } else {
      sections.push(...nonVCXSections)
    }

    const expandedConcept = concepts.find(
      (concept) => concept.id === selectedConceptId,
    )
    const closedConcepts = concepts.filter(
      (concept) => concept.id !== selectedConceptId,
    )

    return (
      showDropdown && (
        <MenuItemDropdown>
          {expandedConcept && !isVCX && !isSnackPack && (
            <MenuItemGroup
              key={expandedConcept.id}
              onSelect={this.onSelectConceptMenuItem(
                expandedConcept.id,
                expandedConcept.name,
              )}
              groupName={`Concept: ${expandedConcept.name}`}
              isExpanded={true}
              menuItems={expandedConcept.items}
            />
          )}
          {!isVCX &&
            !isSnackPack &&
            closedConcepts.map((c) => (
              <MenuItemGroup
                key={c.id}
                onSelect={this.onSelectConceptMenuItem(c.id, c.name)}
                groupName={`Concept: ${c.name}`}
                isExpanded={false}
                menuItems={c.items}
              />
            ))}
          {sections.map((s) => {
            const hideNonCust = isSnackPack && s.name === 'Virtual Items'

            return (
              <MenuItemGroup
                key={s.name}
                onSelect={this.onSelectMenuItem}
                onSelectServiceItem={this.onSelectServiceItem}
                onSelectVirtualItem={this.onSelectVirtualItem}
                onSelectVirtualKit={this.onSelectVirtualKit}
                onSelectSnackPack={this.onSelectSnackPack}
                groupName={s.name}
                isExpanded={menuSearch ? s.items.length > 0 : true}
                menuItems={s.items}
                hideNonCustom={hideNonCust}
                addCustomText={s.addCustomText}
                onCreateCustom={s.onCreateCustom}
              />
            )
          })}
        </MenuItemDropdown>
      )
    )
  }

  render() {
    const { selectedChef, menuItems, menuSearch, showDropdown } = this.state
    const areMenuItemsLoaded = !(
      Object.keys(menuItems).length === 0 && menuItems.constructor === Object
    )

    return (
      <FlexContainer alignItems="flex-start">
        <FormInputContainer width="90%" marginBottom="20px">
          <input
            type="text"
            placeholder="Search items..."
            value={menuSearch}
            onFocus={this.refreshMenu}
            onInput={this.onSearchMenuItem}
            onClick={() => this.setState({ showDropdown: true })}
          />
          {showDropdown && !areMenuItemsLoaded && <Loader isCenter={true} />}
          {selectedChef && areMenuItemsLoaded && this.renderMenuItems()}
        </FormInputContainer>
        <XSpacing width="20px" />
        <LinkText
          onClick={() => this.setState({ showDropdown: false })}
          label="close"
        />
      </FlexContainer>
    )
  }
}

ItemPicker.propTypes = {
  chefs: PropTypes.arrayOf(PropTypes.object),
  selectedChef: PropTypes.object,
  clientSetUpTime: PropTypes.instanceOf(Moment),
  selectedConceptId: PropTypes.string,
  selectedMenuItems: PropTypes.arrayOf(PropTypes.object),
  selectedServiceItems: PropTypes.arrayOf(PropTypes.object),
  selectedVirtualItems: PropTypes.arrayOf(PropTypes.object),
  selectedVirtualKits: PropTypes.arrayOf(PropTypes.object),
  selectedSnackPacks: PropTypes.arrayOf(PropTypes.object),
  errors: PropTypes.object,

  filterMenuItems: PropTypes.func,
  loadCateringMenuItems: PropTypes.func,
  loadChefs: PropTypes.func,
  loadConcepts: PropTypes.func,
  loadServiceItems: PropTypes.func,
  loadVirtualItems: PropTypes.func,
  loadVirtualKits: PropTypes.func,
  loadSnackPacks: PropTypes.func,
  onChange: PropTypes.func,
  onCreateCustomMenuItem: PropTypes.func,
  onCreateCustomServiceItem: PropTypes.func,
  onCreateCustomVirtualItem: PropTypes.func,
  onClearOrderItems: PropTypes.func,
  onSelectChef: PropTypes.func,
  onSelectMenuItem: PropTypes.func,
  onSelectServiceItem: PropTypes.func,
  onSelectVirtualItem: PropTypes.func,
  onSelectVirtualKit: PropTypes.func,
  onSelectSnackPack: PropTypes.func,

  orderId: PropTypes.string,
  orderType: PropTypes.string,
  proposalId: PropTypes.string,
}

ItemPicker.defaultProps = {
  errors: {},
  selectedMenuItems: [],
}

export default ItemPicker
